import { useEffect } from "react";

export const APP_TITLE = "PES ScentsCheck";

export const formatPageTitle = (pageTitle?: string): string => {
  const trimmedTitle = pageTitle?.trim();
  if (!trimmedTitle) {
    return APP_TITLE;
  }
  return `${trimmedTitle} | ${APP_TITLE}`;
};

export const usePageTitle = (pageTitle?: string): void => {
  useEffect(() => {
    document.title = formatPageTitle(pageTitle);

    return () => {
      document.title = APP_TITLE;
    };
  }, [pageTitle]);
};
